import onetrust from '@lib/cookies/onetrust'

const consentInitialization = (provider?: CookiesConsentProvider) => {
  switch (provider) {
    case 'onetrust':
      return onetrust.insertScripts()
    default:
      return
  }
}

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
  return match ? /* istanbul ignore next */ match[2] : null
}

const maxAge = 60 * 60 * 24 * 90 // 90 days

const cookies = {
  consentInitialization,
  consent: {
    get: () => {
      const value = getCookie('cookiesConsent')
      /* istanbul ignore next */
      if (value == null) return null
      /* istanbul ignore next */
      return value === 'true'
    },
    set: (accepted: boolean) =>
      (document.cookie = `cookiesConsent=${accepted}; max-age=${maxAge}; path=/; SameSite=Lax;`),
  },
}

export default cookies
